// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2837":"bb7e947d6f96b380","2888":"0a2724686e73ca53"}[chunkId] + ".css";
};